const  canTakeLeaveThisMonth = (monthlyLeavesAllowed, totalYearlyLeaves, joiningDateStr, leavesTaken)=> {
  const today = new Date();
  const currentYear = today.getFullYear();
  console.log("currentYear" , currentYear);
  const currentMonth = today.getMonth() + 1; // 1–12
  const joiningDate = new Date(joiningDateStr);

  // if joined this year, start from joining month; else start from Jan
  const startMonth =
    joiningDate.getFullYear() === currentYear
      ? joiningDate.getMonth() + 1
      : 1;
     console.log("joiningDate.getFullYear()" , joiningDate.getFullYear() , startMonth) 

  // if joining is in the future -> no leave
  if (
    joiningDate.getFullYear() > currentYear ||
    (joiningDate.getFullYear() === currentYear && startMonth > currentMonth)
  ) {
    return false;
  }

  // months accrued till current month only
  const monthsAccrued = currentMonth - startMonth + 1;
  console.log("monthsAccrued" , monthsAccrued , currentMonth , startMonth)

  let accruedLeaves = monthsAccrued * monthlyLeavesAllowed;
  console.log("accruedLeaves" , accruedLeaves)
  accruedLeaves = Math.min(accruedLeaves, totalYearlyLeaves);
  console.log("accruedLeaves 2" , accruedLeaves)
  // remaining leaves till now
  const remainingLeaves = accruedLeaves - leavesTaken;
  console.log("remainingLeaves" , remainingLeaves)

  return { leave: remainingLeaves ,  remainingLeaves : remainingLeaves > 0 ? true : false}
}

export default canTakeLeaveThisMonth;